import { useState } from 'react';
import Button, { ButtonState } from '../../../../components/button/Button';
import { IconType } from '../../../../components/icon/Icon';
import ToastManager, {
  toastService,
} from '../../../../components/toast/Toasts';
import { TooltipPlacement } from '../../../../components/tooltip/tooltip';
import {
  makeDownloadedToast,
  makeDownloadingToast,
} from '../../../../components/toast/ToastUtils';
import { exportToExcel, pollJobStatus } from '../../../services/dataService';

export const ExportButton: React.FC<{ enabled: boolean }> = ({ enabled }) => {
  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  const handleExport = async () => {
    setLoading(true);
    setDownloadUrl(null);

    const downloadingToast = makeDownloadingToast(1);
    const toastId = `export-toast-${Math.random().toString(36).substr(2, 9)}`;
    toastService.add({ ...downloadingToast, id: toastId });

    try {
      const { statusUrl } = await exportToExcel();
      const { deliveryUrl, fileName } = await pollJobStatus(statusUrl);

      setDownloadUrl(deliveryUrl);

      toastService.remove(toastId);
      toastService.add(
        makeDownloadedToast({
          duration: 0,
          message: {
            type: 'info',
            description: `<h7><strong>Download Ready</strong></h7>
                    <p>Your files are ready to download.</p>`,
          },
          fileName,
          downloadUrl: deliveryUrl,
        })
      );
    } catch (err) {
      toastService.remove(toastId);
      toastService.add({
        message: {
          type: 'error',
          description: 'Export failed. Please try again later.',
          icon: IconType.Error,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        label={downloadUrl ? 'Download' : 'Export'}
        icon={IconType.Download}
        state={enabled && !loading ? ButtonState.DEFAULT : ButtonState.DISABLED}
        isSmall
        tooltip={
          enabled
            ? undefined
            : {
                content: 'You need to login to use this functionality',
                placement: TooltipPlacement.BOTTOM,
                interactive: true,
                maxWidth: 350,
              }
        }
        onClick={
          downloadUrl ? () => window.open(downloadUrl, '_blank') : handleExport
        }
        extraClasses="mobile-buttons export-button"
      />
      <ToastManager />
    </>
  );
};
